export class PaymentOption {
    public imgPath: string;
    public instrumentNumber: string;
    public paymentMethod: string;
    public paymentText: string;
    public sportsOnly: boolean;
    public bankAccountsOnly: boolean;
    public ESIntensiveGreyOut: boolean;
    public isESRiskPlayer: boolean;
    public BANK_INSTRUMENT_LIST?: BANKS_LIST[];
    public userMaxFailDepStatus?: {
        expiryTime?: number;
        blocked?: boolean;
        blockEndDate?: string;
        blockEndTime?: string;
    };
}
export interface PaymentOptionInfo {
    imgPath: string;
    instrumentNumber: string;
    paymentMethod: string;
    paymentText: string;
    sportsOnly: boolean;
    bankAccountsOnly: boolean;
    isESRiskPlayer: boolean;
    ESIntensiveGreyOut: boolean;
    userMaxFailDepStatus: {
        expiryTime?: number;
        blocked?: boolean;
        blockEndDate?: string;
        blockEndTime?: string;
    };
}
export class BANKS_LIST {
    accountNumber: string;
    bankCode: string;
    bankName: string;
    branchCode: string;
}
